import React from 'react'
 import { isMobile, isProduction, imageUrl } from "../helpers/ApplicationHelper"
import { Grid } from "@material-ui/core";
import I18n from "lib/i18n/i18n";
import UserActions from "lib/userActions";

const RecentDeals = (props) => {
    return (
        <Grid
            container
            spacing={isMobile() ? 16 : 24} className={'recent-deals-container'} >
            {
                props.deals.map((deal, i) => (
                    <DealItem key={`deal-item-${i}`} deal={deal} index={i} />
                ))
            }
        </Grid>
    )
}

export default RecentDeals

const DealItem = (props) => {
    const {deal, index, itemId, version} = props
    const styles = {
        textAlign: 'center',
        color: '#000000',
    };

    return (
        <Grid item xs={isMobile() ? 6 : 3} key={`container-${index}`} style={styles} onClick={() => {
            UserActions.lightTrendsPage('Similar item has been clicked', itemId, version)
            window.open(deal.item_deal_url, isMobile() ? '_self' : '_blank');
        }}>
            <div key={`deal-${index}`} className="deal-item">
                <img key={`img-${index}`}
                    src={ deal.item_image_featured || !isProduction() && imageUrl('item/lightTrends/default.jpg')}
                />
                <div key={`price-${index}`} className={'sold-line'}>
                    {I18n.getString('itemPage::lightTrends::recentDealSoldFor')} <b key={`b-${index}`}>{deal.amount}</b>
                </div>
                <div key={`desc-${index}`} className={'sold-desc'}>{deal.name}</div>
            </div>
        </Grid>
    )
}